import {
  SET_TOTAL_PAGES_TABLE,
  SET_ITEMS_PER_PAGE_TABLE,
  SET_CURRENT_PAGE_TABLE
} from '../../../tables/types';

import {
  FETCH_DATA_CAMBIO_ADICIONAL,
  GET_DATA_ROWS_CAMBIO_ADICIONAL,
  SET_DATA_ROWS_CAMBIO_ADICIONAL
} from './types';

const store = {};

const getDefaultState = () => ({
  rows_data: []
});

store.state = getDefaultState();

store.getters = {
  [GET_DATA_ROWS_CAMBIO_ADICIONAL](state) {
    return state.rows_data;
  }
};

store.mutations = {
  [SET_DATA_ROWS_CAMBIO_ADICIONAL](state, payload) {
    state.rows_data = payload;
  }
};

store.actions = {
  [FETCH_DATA_CAMBIO_ADICIONAL]({ dispatch, commit }) {
    // hice esto para cuando haga el fetch de la tabla, aca voy a obtener la cantidad de rows
    // la página actual, cuantos quedan y todo con respecto a la tabla
    // con esto se los voy a pasar al vuex que contiene la data de las tablas
    dispatch(SET_TOTAL_PAGES_TABLE, 30);
    dispatch(SET_ITEMS_PER_PAGE_TABLE, 15);
    dispatch(SET_CURRENT_PAGE_TABLE, 1);
    commit(SET_DATA_ROWS_CAMBIO_ADICIONAL, [
      {
        id: 1,
        key: 1,
        stateReproceso: 'En aseguradora',
        holding: 'Sable',
        subHolding: 'Grupo sable',
        businessName: 'Jumpitt',
        insuranceCompany: 'consorcio',
        period: '2022-08',
        action: 1
      },
      {
        id: 2,
        key: 2,
        stateReproceso: 'Cancelado',
        holding: '',
        subHolding: 'Grupo Mandomedio',
        businessName: 'icar +10',
        insuranceCompany: 'bci seguros',
        period: '2022-08',
        action: 1
      },
      {
        id: 3,
        key: 3,
        stateReproceso: 'En aseguradora',
        holding: 'Sable',
        subHolding: 'Grupo sable',
        businessName: 'Jumpitt',
        insuranceCompany: 'bci seguros',
        period: '2022-08',
        action: 1
      },
      {
        id: 4,
        key: 4,
        stateReproceso: 'Aprobado',
        holding: 'Sable',
        subHolding: 'Grupo sable',
        businessName: 'Jumpitt',
        insuranceCompany: 'bci seguros',
        period: '2022-08',
        action: 1
      }
    ]);
  }
};

export default store;
